import React from 'react';
import { useIntegrations } from '~/contexts';
import SyncIcon from './SyncIcon';
import XeroGrey from './XeroGrey';
import SageGrey from './SageGrey';
import QBOGrey from '~/routes/app/projects/assets/qbo-grey.svg?react';

export default function AccountingIntegrationIcon() {
  const integrations = useIntegrations();

  const active = [integrations.qbo, integrations.xero, integrations.sage].filter(Boolean);
  if (active.length > 1) return <SyncIcon />;
  if (integrations.qbo) return <QBOGrey style={{ width: '1rem', height: '1rem' }} />;
  if (integrations.sage) return <SageGrey />;
  return <XeroGrey />;
}
